<template>
  <v-card elevation="0">
    <v-card-title v-if="hasRoleComprador && showNegociar">
      <v-row dense no-gutters class="d-flex justify-end">
        <v-btn color="primary"
              class="normal-btn-text rounded-tag-small elevation-0"
              :disabled="showCadastro"
              @click="onClickNegociar">
          <v-icon>
            mdi-plus
          </v-icon>
          Negociação
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text class="text--primary">
      <div v-if="showCadastro">
        <px-resposta-negociacao-cadastro
          :resposta="resposta"
          :dialog="dialog"
          @cancel="onCancel"
          @negociacao-enviada="onEnviada"/>
      </div>
      <div v-if="!loading && !negociacoes.length"
           align="center"
           class="headline mb-5">
        Ainda não há nenhuma negociação realizada
      </div>
      <div id="respostaNegociacao" v-if="negociacoes.length">
        <px-resposta-negociacao-lista :negociacoes="negociacoes" :resposta="resposta"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import { mapGetters } from 'vuex';
import NegociacaoService from './negociacao-service';
import RespostaNegociacaoCadastro from './cadastro/RespostaNegociacaoCadastro.vue';
import RespostaNegociacaoLista from './lista/RespostaNegociacaoLista.vue';

export default {
  props: {
    resposta: Object,
    dialog: Boolean,
  },
  data() {
    return {
      loading: false,
      negociacoes: [],
      showCadastro: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    showNegociar() {
      return this.resposta.cotacao.situacao === SituacaoCotacao.keys.ABERTA.key
       || this.resposta.cotacao.situacao === SituacaoCotacao.keys.EM_ANDAMENTO.key;
    },
  },
  methods: {
    onClickNegociar() {
      this.showCadastro = true;
    },
    onCancel() {
      this.showCadastro = false;
    },
    onEnviada() {
      this.showCadastro = false;
      this.$emit('negociacao-enviada');
      this.getNegociacoes();
    },
    getNegociacoes() {
      this.loading = true;
      NegociacaoService.getNegociacoes(this.resposta.cotacao.id, this.resposta.id)
        .then((response) => {
          this.negociacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getNegociacoes();
  },
  components: {
    pxRespostaNegociacaoCadastro: RespostaNegociacaoCadastro,
    pxRespostaNegociacaoLista: RespostaNegociacaoLista,
  },
};
</script>
